import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";

import CultureHQVideoStudioIcon from "images/CultureHQ-Video-Studio-Icon.png";
import { Trans, t } from "app/utils";
import MediaVersionHistory from "./actions/MediaVersionHistory";
import { CreatomateContext } from "../contexts/VideoStudioContext";
import { VIDEO_TYPE } from "../utils/constants";

interface ModalTitleProps {
  preview: Preview;
}

const Title: React.FC<{ text: string }> = ({ text }) => (
  <>
    <h2 className="chq-pan--hd__title" id="video-studio-title"><Trans>CultureHQ{" "}{text}{" "}Studio</Trans></h2>
    <h2 className="chq-pan--hd__title__smaller"><Trans>CHQ{" "}{text}{" "}Studio</Trans></h2>
  </>
);

const StudioTitle: React.FC<ModalTitleProps> = ({ preview }) => {
  const { data } = useContext(CreatomateContext);
  const { mediaType, montage } = data;

  if (montage) return <Title text="Video" />;

  return (
    <>
      <Title text={mediaType === VIDEO_TYPE ? "Video" : "Image"} />
      <MediaVersionHistory preview={preview} />
    </>
  );
};

const ModalTitle: React.FC<ModalTitleProps> = ({ preview }) => (
  <div className="chq-pan--hd__logo">
    <img src={CultureHQVideoStudioIcon} alt={t("CHQ Studio")} />
    <div className="video-studio-title-container">
      <StudioTitle preview={preview} />
    </div>
  </div>
);

export default ModalTitle;
